<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-funnel-dollar"></i> Pengisian Dana Gudang
                </div>
                <div class="card-tools mr-1">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <router-link :disabled="isLoading" class="btn btn-primary" :to="'/pengisian-dana-gudang/history'">
                        <i class="fas fa-history"></i> Riwayat Dana Gudang
                    </router-link>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar is-pengisian @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/gudangs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action" slot-scope="props">
                            <button v-if="$can('create pengisian dana gudang') || isSuperAdmin" type="button" title="Pengisian Dana Gudang" @click="createPengisian(props.rowData)" class="btn btn-link px-1"><i class="fas fa-funnel-dollar"></i></button>
                            <button v-if="props.rowData.saldo_rekening_gudang && ($can('create pengisian dana gudang') || isSuperAdmin)" type="button" title="Penarikan Dana Gudang" @click="createPenarikan(props.rowData)" class="btn btn-link px-1"><i class="fas fa-coins"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="pengisianModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form :isPenarikan="isPenarikan" :gudang="currentGudang" @saved="saved" @cancel="pengisianModal = false"></edit-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';
import EditForm from './Form';

export default {
    name: "pengisian-dana-gudang",

    components: {
        SearchBar,
        Viewer,
        EditForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentGudang: null,
            searchText: '',
            searchDate: '',
            searchGudangId: '',
            viewModal: false,
            pengisianModal: false,
            isPenarikan: false,
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'name',
                    title: 'Gudang',
                    sortField: 'name',
                },
                {
                    name: 'saldo_rekening_gudang',
                    title: 'Rekening Gudang',
                    sortField: 'saldo_rekening_gudang',
                    callback: 'formatNumberStrict',
                },
                {
                    name: 'saldo_kas_kecil',
                    title: 'Kas Kecil',
                    sortField: 'saldo_kas_kecil',
                    callback: 'formatNumberStrict',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                gudang_id: this.searchGudangId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchGudangId = search.searchGudangId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudangId = '';
            this.refresh();
        },

        addNew() {
            this.currentGudang = null;
            this.pengisianModal = true;
        },

        createPengisian(rowData) {
            this.isPenarikan = false;
            this.currentGudang = Object.assign({}, rowData);
            this.pengisianModal = true;
        },

        createPenarikan(rowData) {
            this.isPenarikan = true;
            this.currentGudang = Object.assign({}, rowData);
            this.pengisianModal = true;
        },

        view(rowData) {
            this.isPenarikan = false;
            this.currentGudang = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.pengisianModal = false;
            this.viewModal = false;
            this.currentGudang = null;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/pengisian-gudangs/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/rekening-gudangss/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
